import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import ProductDetailActionsQuestion from './ProductDetailActionsQuestion';

export interface ProductDetailActionsProps extends StandardDivProps<ProductDetailActionsClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailActionsClassKey = 'root';

const themeSettings = { name: 'ProductDetailActions' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<ProductDetailActionsClassKey, {}>({
      root: {
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'flex-end',
        [theme.breakpoints.down('sm')]: { justifyContent: 'center' },
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
          alignItems: 'center',
        },
        '& > div': {
          marginRight: theme.spacing(1),
          [theme.breakpoints.down('xs')]: {
            '&:last-of-type': {
              marginTop: theme.spacing(1),
            },
          },
        },
      },
    }),
  themeSettings,
);

const ProductDetailActions = React.forwardRef<HTMLDivElement, ProductDetailActionsProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        <ProductDetailActionsQuestion product={product} />
      </div>
    );
  },
);

ProductDetailActions.displayName = 'ProductDetailActions';

export default withThemeProps(themeSettings)(ProductDetailActions);
